import Toast from 'components/Toast';

export const displayError = (errText: string) => {
	Toast.error(errText);
};
